import { z } from 'zod';

export const HealthResponse = z.object({
  ok: z.boolean(),
  version: z.string(),
  db: z.boolean(),
});
export type HealthResponse = z.infer<typeof HealthResponse>;
